import TrainingDataIndex from './TrainingDataIndex';
import TrainingDataCreate from './TrainingDataCreate';
import TrainingDataSettings from './TrainingDataSettings';
import TrainingDataSingle from './TrainingDataSingle';

export default function (app) {

    const settings = TrainingDataSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    app.addMenu({
        key: settings.key,
        zone: settings.zone,
        label: settings.title,
        priority: 15,
        items: [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            }
        ],
    });

    TrainingDataIndex(app, settings);

    TrainingDataCreate(app, settings);

    TrainingDataSingle(app, settings);

}